import { Component, Inject } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { firstValueFrom } from "rxjs";
import { FormValidators } from "src/app/common/validators/form-validators";
import LocalizationConstants from "src/app/constants/localization-constants";
import { TechCoverContact } from "src/app/models/TechCoverContact";
import { ModalComponent } from "src/app/services/modal.service";

type FamCodesListType = { famCodes: string[] };

@Component({
  selector: "app-contacts-create-modal",
  templateUrl: "./contacts-create-modal.component.html",
  standalone: false,
})
export class ContactsCreateModalComponent
  implements ModalComponent<ContactsCreateModalComponent, FamCodesListType, TechCoverContact>
{
  readonly localizationConstants = LocalizationConstants;
  readonly maxLengthEmail = 200;
  readonly maxLengthPhone = 20;

  form: FormGroup;
  famCodeControl = new FormControl("", [
    Validators.required,
    Validators.maxLength(3),
    Validators.minLength(3),
  ]);
  emailControl = new FormControl("", [
    Validators.required,
    Validators.email,
    Validators.maxLength(this.maxLengthEmail),
  ]);
  phoneControl = new FormControl("", [Validators.maxLength(this.maxLengthPhone)]);

  famCodes: string[] = [];
  famCodeSelectionPlaceHolder: string = "";

  constructor(
    public dialogRef: MatDialogRef<ContactsCreateModalComponent, TechCoverContact>,
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: { famCodes: string[] },
  ) {
    this.dialogRef.disableClose = true;
    this.famCodes = data.famCodes;
    this.setForm();
    this.setTranslationAsync();
  }

  public closeDialog(shouldAddContact: boolean): void {
    this.dialogRef.close(shouldAddContact ? this.form.value : null);
  }

  private setForm(): void {
    this.form = new FormGroup({
      famCode: this.famCodeControl,
      email: this.emailControl,
      phone: this.phoneControl,
    });

    if (this.famCodes.length > 1) {
      this.famCodeControl.addValidators([FormValidators.isFamCodeAllowedForUser(this.famCodes)]);
    }
  }

  private async setTranslationAsync(): Promise<void> {
    this.famCodeSelectionPlaceHolder = await firstValueFrom(
      this.translateService.get(
        LocalizationConstants.TECH_COVER_CONTACT_ADD_CONTACT_FAM_PLACEHOLDER,
      ),
    );
  }
}
